import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const WaitlistModal = ({ product, open, onOpenChange }) => {
  const [form, setForm] = useState({ nome: "", email: "", telefono: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/leads/shop-waitlist", {
        ...form, product_id: product.id, product_name: product.name,
      });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nell'invio, riprova.");
    } finally {
      setSending(false);
    }
  };

  const close = (v) => {
    onOpenChange(v);
    if (!v) setTimeout(() => { setDone(false); setForm({ nome: "", email: "", telefono: "" }); }, 300);
  };

  const cls = "w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#E4BD44] outline-none px-4 py-3 text-sm text-[#F9F6F0] placeholder-[#777]";
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-[#141414] border-[#2A2A2A] text-[#F9F6F0]" data-testid="shop-waitlist-modal">
        <DialogHeader>
          <DialogTitle className="font-display">Richiedi info</DialogTitle>
          <DialogDescription className="text-[#9a9484]">{product?.name}</DialogDescription>
        </DialogHeader>
        {done ? (
          <div className="border border-[#E4BD44] bg-[#E4BD44]/10 px-5 py-7 text-center" data-testid="shop-waitlist-success">
            <p className="font-bold leading-relaxed">✅ Sei in lista! Ti avviseremo appena il corso sarà disponibile.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="shop-waitlist-form">
            <input type="text" required minLength={2} value={form.nome} onChange={set("nome")}
              placeholder="Il tuo nome" className={cls} data-testid="shop-waitlist-nome" />
            <input type="email" required value={form.email} onChange={set("email")}
              placeholder="La tua email" className={cls} data-testid="shop-waitlist-email" />
            <input type="tel" required minLength={5} value={form.telefono} onChange={set("telefono")}
              placeholder="Il tuo telefono" className={cls} data-testid="shop-waitlist-telefono" />
            <button type="submit" disabled={sending} data-testid="shop-waitlist-submit"
              className="w-full btn-primary justify-center !py-3 text-sm disabled:opacity-60">
              {sending ? "Invio in corso…" : "RICHIEDI INFO →"}
            </button>
            <p className="text-[11px] text-[#9a9484] text-center">Nessuno spam. Solo aggiornamenti Wildersquad.</p>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
